import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import logo from './acme-loans.webp';
import './App.css';
import Loan from './components/Loan';
import Redirect from './components/Redirect';

class App extends Component<any, any> {
    render() {
        return (
                <div className="App">
                    <header className="App-header">
                        <img src={logo as string} className="App-logo" alt="logo"/>
                    </header>
                    <main className="App-content">
                        <Router>
                            <Routes>
                                <Route path="/" element={<Loan/>}/>
                                <Route path="/redirect" element={<Redirect/>}/>
                            </Routes>
                        </Router>
                    </main>
                </div>
        );
    }
}

export default App;
